import { CurrentMembershipPermissionsType } from '@identity/graphql';

export type ArticleType = {
  id: string;
  title: string;
  subtitle: string;
  contentSample: string;
  url: string;
  necessaryPermission?: keyof CurrentMembershipPermissionsType;
};

export const QUICK_ARTICLES: ArticleType[] = [
  {
    id: '6888628',
    title: 'How does Reopen work / How does a dispute become Reopened?',
    subtitle: '',
    contentSample:
      'After a dispute has been Rejected (by an Organization) or Retracted (by a Supplier), a dispute may be reopened by the Supplier.  ',
    url: 'https://help.workshealth.com/en/articles/6888628-how-does-reopen-work-how-does-a-dispute-become-reopened',
    necessaryPermission: 'canShowDisputes',
  },
  {
    id: '6891104',
    title: 'Can a dispute status change when an invoice is voided?',
    subtitle: '',
    contentSample:
      "When an invoice that resolves an existing dispute is voided, the dispute's status will update from Resolved to Reopened (it won't be archived).",
    url: 'https://help.workshealth.com/en/articles/6891104-can-a-dispute-status-change-when-an-invoice-is-voided',
    necessaryPermission: 'canShowDisputes',
  },
  {
    id: '6888626',
    title: 'How does Works Bot help with disputes?',
    subtitle: '',
    contentSample:
      "Changes to disputes can either happen by users or by one of our system's automatic processes.  Works Bot is the “user” that we display when a change is made by an automatic process.",
    url: 'https://help.workshealth.com/en/articles/6888626-how-does-works-bot-help-with-disputes',
    necessaryPermission: 'canShowDisputes',
  },
  {
    id: '6888624',
    title: 'How does a dispute become resolved?',
    subtitle: '',
    contentSample:
      'When an organization corrects a line item on a subsequent invoice, our system matches this information and updates the dispute status to Resolved.',
    url: 'https://help.workshealth.com/en/articles/6888624-how-does-a-dispute-become-resolved',
    necessaryPermission: 'canShowDisputes',
  },
  {
    id: '6888622',
    title: 'What happens when a dispute is archived?',
    subtitle: '',
    contentSample:
      'Disputes are archived because they are associated with an invoice that has been voided.',
    url: 'https://help.workshealth.com/en/articles/6888622-what-happens-when-a-dispute-is-archived',
    necessaryPermission: 'canShowDisputes',
  },
  {
    id: '6888611',
    title: 'What happens when an invoice/reverse invoice is voided?',
    subtitle: '',
    contentSample:
      'When invoices/reverse invoices are voided, their status will change to "Void."',
    url: 'https://help.workshealth.com/en/articles/6888611-what-happens-when-an-invoice-reverse-invoice-is-voided',
    necessaryPermission: 'canShowInvoices',
  },
  {
    id: '5145463',
    title: 'How do I pick a start date when sending an offer?',
    subtitle: '',
    contentSample:
      'Congratulations! You found the right candidate for your open position and want to send them an offer.',
    url: 'https://help.workshealth.com/en/articles/5145463-how-do-i-pick-a-start-date-when-sending-an-offer',
    necessaryPermission: 'canCreateOffers',
  },
  {
    id: '4828545',
    title:
      'How do I review a candidate application that is marked “in review”?',
    subtitle: '',
    contentSample:
      "Once your Works Success Partner reviews a candidate's application to ensure they meet basic position requirements, they will update the application status to In Review.",
    url: 'https://help.workshealth.com/en/articles/4828545-how-do-i-review-a-candidate-application-that-is-marked-in-review',
    necessaryPermission: 'canShowApplications',
  },
  {
    id: '4828495',
    title: 'How do I update the status of an application that is in review?',
    subtitle: '',
    contentSample: 'Start on the Candidates tab.',
    url: 'https://help.workshealth.com/en/articles/4828495-how-do-i-update-the-status-of-an-application-that-is-in-review',
    necessaryPermission: 'canUpdateApplications',
  },
  {
    id: '4828532',
    title: 'How do I reject an applicant?',
    subtitle: '',
    contentSample:
      'To reject an applicant, navigate to the profile details page of the appropriate candidate. ',
    url: 'https://help.workshealth.com/en/articles/4828532-how-do-i-reject-an-applicant',
    necessaryPermission: 'canUpdateApplications',
  },
  {
    id: '4828559',
    title: 'How do I extend an offer to a candidate?',
    subtitle: '',
    contentSample:
      'To extend an offer an applicant, navigate to the profile details page of the appropriate candidate.',
    url: 'https://help.workshealth.com/en/articles/4828559-how-do-i-extend-an-offer-to-a-candidate',
    necessaryPermission: 'canCreateOffers',
  },
  {
    id: '4828535',
    title: "What do I see if I click on a specific candidate's application?",
    subtitle: '',
    contentSample:
      "If you are on the Candidates tab and click on a candidate's name, it will bring you to the candidate's profile page, where you'll be able to see the:",
    url: 'https://help.workshealth.com/en/articles/4828535-what-do-i-see-if-i-click-on-a-specific-candidate-s-application',
    necessaryPermission: 'canShowApplications',
  },
  {
    id: '4828494',
    title: 'What does the candidates tab show me?',
    subtitle: '',
    contentSample:
      'The candidates tab lists every application that has been submitted for a staffing request at your unit(s) or location.',
    url: 'https://help.workshealth.com/en/articles/4828494-what-does-the-candidates-tab-show-me',
    necessaryPermission: 'canShowApplications',
  },
  {
    id: '4828487',
    title: 'What are each of the application statuses and what do they mean?',
    subtitle: '',
    contentSample:
      'In Review: These applications have been reviewed by your Works Success Partner and are ready for you to take a look at.',
    url: 'https://help.workshealth.com/en/articles/4828487-what-are-each-of-the-application-statuses-and-what-do-they-mean',
    necessaryPermission: 'canShowApplications',
  },
  {
    id: '6193982',
    title: 'Staffing Agency | Offer Change Request Process',
    subtitle:
      'Walkthrough of the Offer Change Request feature and functionality.',
    contentSample: 'What is the Offer Change Request feature?',
    url: 'https://help.workshealth.com/en/articles/6193982-staffing-agency-offer-change-request-process',
    necessaryPermission: 'canShowOffers',
  },
  {
    id: '6194748',
    title: 'Facility/MSP | Offer Change Request Process',
    subtitle:
      'Walkthrough of the Offer Change Request feature and functionality.',
    contentSample: 'What is the Offer Change Request feature?',
    url: 'https://help.workshealth.com/en/articles/6194748-facility-msp-offer-change-request-process',
    necessaryPermission: 'canShowOffers',
  },
  {
    id: '6542614',
    title: 'Do Not Rehire: Feature Overview',
    subtitle:
      'This article outlines the Do Not Use feature within the Works platform, which flags candidates potentially ineligible for future submission.',
    contentSample:
      'Reader note: This is the Do Not Use / Do Not Rehire feature. The Works platform uses the terminology "Do Not Rehire", and therefore we use this term in this article',
    url: 'https://help.workshealth.com/en/articles/6542614-do-not-rehire-feature-overview',
    necessaryPermission: 'canShowDoNotRehires',
  },
  {
    id: '4868336',
    title: 'How do I withdraw a submission?',
    subtitle: '',
    contentSample:
      'First, navigate to the Requests tab and click on a staffing request. ',
    url: 'https://help.workshealth.com/en/articles/4868336-how-do-i-withdraw-a-submission',
    necessaryPermission: 'canWithdrawApplications',
  },
  {
    id: '4868322',
    title: 'How do I review a submission?',
    subtitle: '',
    contentSample:
      'First, navigate to the Requests tab and click on the name of the staffing request.',
    url: 'https://help.workshealth.com/en/articles/4868322-how-do-i-review-a-submission',
    necessaryPermission: 'canShowApplications',
  },
  {
    id: '4828580',
    title: 'How do I filter onboarding resources by start date?',
    subtitle: '',
    contentSample:
      'Hiring managers often find it useful to filter by start date within the onboarding tab so they can see which workers are starting soon and plan the schedule accordingly.',
    url: 'https://help.workshealth.com/en/articles/4828580-how-do-i-filter-onboarding-resources-by-start-date',
    necessaryPermission: 'canShowApplications',
  },
  {
    id: '4828574',
    title: 'Who is responsible for approving onboarding/compliance documents?',
    subtitle: '',
    contentSample:
      'Your Works Success Partner or MSP compliance teammate is responsible for approving or rejecting onboarding documents.',
    url: 'https://help.workshealth.com/en/articles/4828574-who-is-responsible-for-approving-onboarding-compliance-documents',
    necessaryPermission: 'canShowWorksLists',
  },
  {
    id: '4828569',
    title:
      "What do I see if I click on a specific candidate's name within onboarding?",
    subtitle: '',
    contentSample:
      "This will bring you to the candidate's assignment profile page, where you'll be able to see the following details:",
    url: 'https://help.workshealth.com/en/articles/4828569-what-do-i-see-if-i-click-on-a-specific-candidate-s-name-within-onboarding',
    necessaryPermission: 'canShowApplications',
  },
  {
    id: '4828565',
    title: 'What does the onboarding tab show me?',
    subtitle: '',
    contentSample:
      'The onboarding tab shows you who is going to be on your team once their compliance is attained.',
    url: 'https://help.workshealth.com/en/articles/4828565-what-does-the-onboarding-tab-show-me',
    necessaryPermission: 'canShowApplications',
  },
  {
    id: '6460511',
    title: 'Seasonal Health Compliance Items',
    subtitle: '',
    contentSample:
      'When adding a Health Document compliance item to a Compliance Template or a Compliance List, you have to option to set it as a seasonal item and specify the date range that it will apply.',
    url: 'https://help.workshealth.com/en/articles/6460511-seasonal-health-compliance-items',
    necessaryPermission: 'canShowWorksLists',
  },
  {
    id: '6458552',
    title: 'Editing Onboarding/Compliance Lists',
    subtitle:
      'Learn more about how you can edit Compliance requirements in bulk or individually by candidate.',
    contentSample:
      "Previously, once an offer had been accepted, the Compliance template tied to the candidate's onboarding was frozen and could not be modified. ",
    url: 'https://help.workshealth.com/en/articles/6458552-editing-onboarding-compliance-lists',
    necessaryPermission: 'canShowWorksLists',
  },
  {
    id: '4847232',
    title: 'What is “time to fill” defined as?',
    subtitle: '',
    contentSample:
      'Time to fill is a metric that measures the average time (in days) it takes for positions associated with a staffing request status to go from “open” to “filled”.',
    url: 'https://help.workshealth.com/en/articles/4847232-what-is-time-to-fill-defined-as',
    necessaryPermission: 'canShowApplications',
  },
  {
    id: '6124750',
    title: 'How do I approve staffing requests and extension offers?',
    subtitle: '',
    contentSample:
      'To approve a Staffing Request or Extension Offer you must be logged in to the Works platform.',
    url: 'https://help.workshealth.com/en/articles/6124750-how-do-i-approve-staffing-requests-and-extension-offers',
    necessaryPermission: 'canUpdateStaffingRequests',
  },
  {
    id: '6118356',
    title: 'How do I create or modify an Approval Chain?',
    subtitle: '',
    contentSample:
      'To create or modify an Approval Chain you must have a Works membership access level that allows you to see the "Admin" tab.',
    url: 'https://help.workshealth.com/en/articles/6118356-how-do-i-create-or-modify-an-approval-chain',
    necessaryPermission: 'canShowAdminApprovalsItem',
  },
  {
    id: '4868363',
    title: 'How can I filter resource statuses within the team tab?',
    subtitle: '',
    contentSample:
      'From the team tab, navigate to the far right-hand side column titled "status." Select the filter icon and select the status(es) you would like to view. ',
    url: 'https://help.workshealth.com/en/articles/4868363-how-can-i-filter-resource-statuses-within-the-team-tab',
    necessaryPermission: 'canShowLongTermAssignments',
  },
  {
    id: '4868362',
    title:
      'What are the different team tab statuses and what do each of them mean?',
    subtitle: '',
    contentSample:
      'Your team members are assigned one of the following eight statuses:',
    url: 'https://help.workshealth.com/en/articles/4868362-what-are-the-different-team-tab-statuses-and-what-do-each-of-them-mean',
    necessaryPermission: 'canShowLongTermAssignments',
  },
  {
    id: '6118345',
    title: 'How do approval chains work?',
    subtitle: '',
    contentSample:
      'Approval chains are a key feature of the Works platform that can help your unit and facility more efficiently manage the approval process and budget impacts associated with new staffing requests and extension offers. ',
    url: 'https://help.workshealth.com/en/articles/6118345-how-do-approval-chains-work',
    necessaryPermission: 'canShowAdminApprovalsItem',
  },
  {
    id: '4868319',
    title:
      'How do I submit a candidate to a particular staffing request if their profile is already created within Works?',
    subtitle: '',
    contentSample:
      'The process of submitting a new candidate depends on whether this candidate already has a profile within Works.',
    url: 'https://help.workshealth.com/en/articles/4868319-how-do-i-submit-a-candidate-to-a-particular-staffing-request-if-their-profile-is-already-created-within-works',
    necessaryPermission: 'canCreateApplications',
  },
  {
    id: '4868316',
    title: "How do I create a candidate's profile within Works?",
    subtitle: '',
    contentSample:
      "Before creating a profile, please double check that a candidate doesn't already have a profile created. You can do this by searching for the candidate's name in the search bar.",
    url: 'https://help.workshealth.com/en/articles/4868316-how-do-i-create-a-candidate-s-profile-within-works',
    necessaryPermission: 'canCreateApplications',
  },
  {
    id: '4868313',
    title: 'What does the candidates tab show me?',
    subtitle: '',
    contentSample:
      'The candidates tab outlines all of the candidates that have a profile in Works. On this tab, you can see their: ',
    url: 'https://help.workshealth.com/en/articles/4868313-what-does-the-candidates-tab-show-me',
    necessaryPermission: 'canShowSidebarCandidatesItem',
  },
  {
    id: '4868312',
    title: 'What does the accepted tab show me?',
    subtitle: '',
    contentSample:
      'This tab shows all the offers that have been accepted by nurses you are representing. For each accepted offer, you will be able to see:',
    url: 'https://help.workshealth.com/en/articles/4868312-what-does-the-accepted-tab-show-me',
    necessaryPermission: 'canShowApplications',
  },
  {
    id: '4868309',
    title: 'How do I accept or reject an offer?',
    subtitle: '',
    contentSample: 'First, navigate to the offers section of the Requests tab.',
    url: 'https://help.workshealth.com/en/articles/4868309-how-do-i-accept-or-reject-an-offer',
    necessaryPermission: 'canUpdateOffers',
  },
  {
    id: '4868306',
    title: 'What does the offers section of the Requests tab show me?',
    subtitle: '',
    contentSample:
      'This tab shows how many outstanding offers your submissions have garnered. For each outstanding offer, you will be able to see:',
    url: 'https://help.workshealth.com/en/articles/4868306-what-does-the-offers-section-of-the-requests-tab-show-me',
    necessaryPermission: 'canShowSidebarStaffingItem',
  },
  {
    id: '4868305',
    title: 'What does the submissions section of the Requests tab show me?',
    subtitle: '',
    contentSample:
      'This tab shows you all the submissions you, as a supplier, have made. For each submission, it will detail:',
    url: 'https://help.workshealth.com/en/articles/4868305-what-does-the-submissions-section-of-the-requests-tab-show-me',
    necessaryPermission: 'canShowSidebarStaffingItem',
  },
  {
    id: '4868299',
    title: 'What do I see once I click into a particular staffing request?',
    subtitle: '',
    contentSample:
      'If you click on the ID associated with a specific staffing request (highlighted in the image below), you will be brought to a page showing you all of the submissions for that particular request.',
    url: 'https://help.workshealth.com/en/articles/4868299-what-do-i-see-once-i-click-into-a-particular-staffing-request',
    necessaryPermission: 'canShowSidebarStaffingItem',
  },
  {
    id: '4868298',
    title: 'How do I filter by staffing request status?',
    subtitle: '',
    contentSample:
      'Suppliers often find it useful to filter by status within the staffing tab so they can see which staffing requests are Open and are still being actively sourced.',
    url: 'https://help.workshealth.com/en/articles/4868298-how-do-i-filter-by-staffing-request-status',
    necessaryPermission: 'canShowSidebarStaffingItem',
  },
  {
    id: '4868290',
    title: 'What does the requests section of the Requests tab show me?',
    subtitle: '',
    contentSample:
      'The requests section shows all the staffing requests ever created by any hiring manager at relevant location or unit(s).',
    url: 'https://help.workshealth.com/en/articles/4868290-what-does-the-requests-section-of-the-requests-tab-show-me',
    necessaryPermission: 'canShowSidebarStaffingItem',
  },
  {
    id: '4868285',
    title: 'What does the requests tab show me?',
    subtitle: '',
    contentSample:
      'The requests tab organizes information within four sections:',
    url: 'https://help.workshealth.com/en/articles/4868285-what-does-the-requests-tab-show-me',
    necessaryPermission: 'canShowSidebarStaffingItem',
  },
  {
    id: '5014967',
    title: 'What browser should you be using to access Works?',
    subtitle: '',
    contentSample:
      'If you were directed here after receiving an error, it is likely because you are using an outdated browser (e.g. Internet Explorer 11).',
    url: 'https://help.workshealth.com/en/articles/5014967-what-browser-should-you-be-using-to-access-works',
  },
  {
    id: '4847228',
    title: 'How do I login?',
    subtitle: '',
    contentSample:
      'Navigate to https://app.workshealth.com/works/sign_in and enter your email address and password.',
    url: 'https://help.workshealth.com/en/articles/4847228-how-do-i-login',
  },
  {
    id: '4806873',
    title: "My email isn't working, what do I do?",
    subtitle: 'Login issue',
    contentSample:
      "If your email address isn't working you will see the screen below.",
    url: 'https://help.workshealth.com/en/articles/4806873-my-email-isn-t-working-what-do-i-do',
  },
  {
    id: '4806876',
    title: "My password isn't working, what do I do?",
    subtitle: 'Login issue',
    contentSample: 'Click on "Forgot Password."',
    url: 'https://help.workshealth.com/en/articles/4806876-my-password-isn-t-working-what-do-i-do',
  },
  {
    id: '4806880',
    title: 'How do I log out?',
    subtitle: 'Logout',
    contentSample:
      'To log out of Works, click on your initials in the top right corner of the webpage and click on “Logout.”',
    url: 'https://help.workshealth.com/en/articles/4806880-how-do-i-log-out',
  },
  {
    id: '6797319',
    title: 'Permissions by User Roles',
    subtitle:
      "In this article you'll learn of the various users roles and their associated permissions within Works.",
    contentSample:
      'Works User Roles are listed below from most permissions to least.',
    url: 'https://help.workshealth.com/en/articles/6797319-permissions-by-user-roles',
  },
  {
    id: '8699393',
    title: 'Email Notifications by Membership Levels',
    subtitle:
      'This article outlines the default email notifications each membership level receives by default in Works.',
    contentSample:
      'This article describes the list of email notifications each membership level receives by default.',
    url: 'https://help.workshealth.com/en/articles/8699393-email-notifications-by-membership-levels',
  },
  {
    id: '9096403',
    title: 'Manage shifts in Works',
    subtitle: '',
    contentSample:
      'Please expand the video by pressing the Play button or by using the [brackets] in the video player for a mobile friendly tutorial.',
    url: 'https://help.workshealth.com/en/articles/9096403-manage-shifts-in-works',
    necessaryPermission: 'canShowShifts',
  },
  {
    id: '9105185',
    title: 'Send shifts to staff',
    subtitle: 'How to send shifts to staff',
    contentSample: '',
    url: 'https://help.workshealth.com/en/articles/9105185-send-shifts-to-staff',
    necessaryPermission: 'canShowShifts',
  },
  {
    id: '4828177',
    title: 'What does the staffing tab show me?',
    subtitle: '',
    contentSample:
      'The staffing tab shows all the staffing requests ever created by any hiring manager at your location or unit(s).',
    url: 'https://help.workshealth.com/en/articles/4828177-what-does-the-staffing-tab-show-me',
    necessaryPermission: 'canShowSidebarStaffingItem',
  },
  {
    id: '4828475',
    title: "How do I download a candidate's submittal packet?",
    subtitle: '',
    contentSample:
      'After clicking on a candidate’s name, scroll to the bottom of their profile details page and click on the link labeled “Download Submittal Packet” within the Submittal Packet section.',
    url: 'https://help.workshealth.com/en/articles/4828475-how-do-i-download-a-candidate-s-submittal-packet',
    necessaryPermission: 'canShowApplications',
  },
  {
    id: '4808835',
    title: 'How do I create a staffing request?',
    subtitle: 'Creating staffing requests as a hiring manager',
    contentSample:
      'In the top right corner of either the Dashboard or Staffing Request tabs, click on the button that reads “+ Staffing Request”.',
    url: 'https://help.workshealth.com/en/articles/4808835-how-do-i-create-a-staffing-request',
    necessaryPermission: 'canUpdateStaffingRequests',
  },
  {
    id: '4828389',
    title:
      'What do I do if a template I need for a staffing request does not exist or if I want to edit an existing staffing request template?',
    subtitle: '',
    contentSample:
      'Email support@workshealth.com or contact us through the chat button on the Works platform.',
    url: 'https://help.workshealth.com/en/articles/4828389-what-do-i-do-if-a-template-i-need-for-a-staffing-request-does-not-exist-or-if-i-want-to-edit-an-existing-staffing-request-template',
    necessaryPermission: 'canShowAdminStaffingRequestTemplates',
  },
  {
    id: '4828393',
    title:
      'What are all the different types of staffing request statuses and what do they mean?',
    subtitle: '',
    contentSample:
      'Staffing requests can either be: Pending, Open, On Hold, Filled or Cancelled.',
    url: 'https://help.workshealth.com/en/articles/4828393-what-are-all-the-different-types-of-staffing-request-statuses-and-what-do-they-mean',
    necessaryPermission: 'canShowSidebarStaffingItem',
  },
  {
    id: '4828401',
    title: 'What do I see if I click on a specific staffing request name?',
    subtitle: '',
    contentSample:
      'Clicking on a staffing request will link you to the staffing request details page, where you’ll see the staffing request’s status, date the status was last updated',
    url: 'https://help.workshealth.com/en/articles/4828401-what-do-i-see-if-i-click-on-a-specific-staffing-request-name',
    necessaryPermission: 'canShowSidebarStaffingItem',
  },
  {
    id: '4828471',
    title: 'How do I filter by staffing request status on the staffing tab?',
    subtitle: '',
    contentSample:
      'Hiring managers often find it useful to filter by status within the staffing tab so they can see which staffing requests are Open and are still being actively sourced.',
    url: 'https://help.workshealth.com/en/articles/4828471-how-do-i-filter-by-staffing-request-status-on-the-staffing-tab',
    necessaryPermission: 'canShowSidebarStaffingItem',
  },
  {
    id: '4828394',
    title:
      'How do I know that a staffing request I have submitted has been approved?',
    subtitle: '',
    contentSample:
      'The staffing request status will be updated from Pending to Open.',
    url: 'https://help.workshealth.com/en/articles/4828394-how-do-i-know-that-a-staffing-request-i-have-submitted-has-been-approved',
    necessaryPermission: 'canShowSidebarStaffingItem',
  },
  {
    id: '6613749',
    title: 'Editing Staffing Requests',
    subtitle: 'What is the Editing Staffing Requests feature?',
    contentSample:
      "This feature allows for different user personas to make modifications on 'Open' Staffing Requests in the Works platform.",
    url: 'https://help.workshealth.com/en/articles/6613749-editing-staffing-requests',
    necessaryPermission: 'canUpdateStaffingRequests',
  },
  {
    id: '4828601',
    title: 'How do I filter my team by assignment end date?',
    subtitle: '',
    contentSample:
      'Hiring managers often find it useful to filter by end date within the team tab so they can see which workers could be up for an extension soon.',
    url: 'https://help.workshealth.com/en/articles/4828601-how-do-i-filter-my-team-by-assignment-end-date',
    necessaryPermission: 'canShowLongTermAssignments',
  },
  {
    id: '4828599',
    title: 'What does the team tab show me?',
    subtitle: '',
    contentSample:
      'This tab is where you can see details about any resource who has worked, is currently working, or will be working on your team in the future.',
    url: 'https://help.workshealth.com/en/articles/4828599-what-does-the-team-tab-show-me',
    necessaryPermission: 'canShowSidebarTeamItem',
  },
  {
    id: '6402568',
    title: 'Editing Assignment Details',
    subtitle: '',
    contentSample:
      'The Works platform now allows Organization Admins and Program Managers to edit certain details on an existing Assignment or Extension rather than going through your Works Support Partner for revisions!',
    url: 'https://help.workshealth.com/en/articles/6402568-editing-assignment-details',
    necessaryPermission: 'canUpdateStaffingRequestAssignments',
  },
  {
    id: '8358226',
    title: "Add time to a worker's timecard in Timecards",
    subtitle:
      "How do I add hours to a worker's time once they submit their timesheet?",
    contentSample:
      "There may be times when a manager needs to add time to a worker's timecard after they have already submitted the timecard.",
    url: 'https://help.workshealth.com/en/articles/8358226-add-time-to-a-worker-s-timecard-in-timecards',
    necessaryPermission: 'canShowSidebarTimesheetsItem',
  },
  {
    id: '8386825',
    title: "How to edit a worker's time entry",
    subtitle:
      "Follow these steps in order to make edits to a worker's submitted timecard.",
    contentSample:
      "There may be times when a manager needs to edit the time on a worker's time entry due to incorrect information.",
    url: 'https://help.workshealth.com/en/articles/8386825-how-to-edit-a-worker-s-time-entry',
    necessaryPermission: 'canShowSidebarTimesheetsItem',
  },
  {
    id: '8386815',
    title: 'I made a mistake on a timecard I approved. Can I edit?',
    subtitle:
      'Steps on how to unapprove a timecard to make any necessary edits.',
    contentSample:
      'There may be times when a manager needs to unapprove a previously approved timecard in order to make edits to the time.',
    url: 'https://help.workshealth.com/en/articles/8386815-i-made-a-mistake-on-a-timecard-i-approved-can-i-edit',
    necessaryPermission: 'canShowSidebarTimesheetsItem',
  },
  {
    id: '8386803',
    title: "How to approve worker's time in Timecards",
    subtitle:
      "Steps to guide a manager through approving a worker's timecard in Works Timecards.",
    contentSample:
      "In order to approve a worker's submitted timecard, follow these steps",
    url: 'https://help.workshealth.com/en/articles/8386803-how-to-approve-worker-s-time-in-timecards',
    necessaryPermission: 'canShowSidebarTimesheetsItem',
  },
  {
    id: '8513722',
    title: 'Timecard status definitions',
    subtitle: 'Descriptions of what each timecard status means',
    contentSample:
      'There are various timecard statuses that you will see when using the Works application.',
    url: 'https://help.workshealth.com/en/articles/8513722-timecard-status-definitions',
    necessaryPermission: 'canShowSidebarTimesheetsItem',
  },
  {
    id: '8538973',
    title: "Delete time from a worker's timecard",
    subtitle: '',
    contentSample:
      "There may be times when a manager needs to remove time from a worker's timecard after they have already submitted the timesheet so that the rest of the timecard can be approved.",
    url: 'https://help.workshealth.com/en/articles/8538973-delete-time-from-a-worker-s-timecard',
    necessaryPermission: 'canShowSidebarTimesheetsItem',
  },
  {
    id: '4853409',
    title: 'How do I unsubscribe from email notifications?',
    subtitle: '',
    contentSample:
      'If you would like to stop receiving email notifications from Works, please email us at support@workshealth.com or contact us by using the live chat button at the bottom right of your screen.',
    url: 'https://help.workshealth.com/en/articles/4853409-how-do-i-unsubscribe-from-email-notifications',
  },
  {
    id: '4833631',
    title: 'What can I use the search bar to find?',
    subtitle: '',
    contentSample:
      'You can use the search bar to search staffing requests, submitted applications, submitted candidates, and assignments.',
    url: 'https://help.workshealth.com/en/articles/4833631-what-can-i-use-the-search-bar-to-find',
  },
  {
    id: '9664157',
    title: 'Disputes Overview',
    subtitle: "Here's a quick overview of disputes!",
    contentSample:
      'There are two main types of disputes: Missing Line Item and Error Dispute.',
    url: 'https://help.workshealth.com/en/articles/9664157-disputes-overview',
    necessaryPermission: 'canShowDisputes',
  },
  {
    id: '9664109',
    title: 'Submitting Missing Line Item Disputes',
    subtitle:
      "Worker's time not found on a reverse invoice? This article will assist with the process of submitting a missing line item in Works.",
    contentSample:
      'Missing Line Item (MLI) disputes are utilized if resource time is completely omitted from an invoice it should be included on.',
    url: 'https://help.workshealth.com/en/articles/9664109-submitting-missing-line-item-disputes',
    necessaryPermission: 'canShowDisputes',
  },
  {
    id: '9664176',
    title: 'Submitting Error Disputes',
    subtitle:
      'Notice an error on a reverse invoice? This article will help you submit an error dispute.',
    contentSample:
      "Error disputes are utilized if a resource's time is present on an invoice, however the information of the line item is incorrect.",
    url: 'https://help.workshealth.com/en/articles/9664176-submitting-error-disputes',
    necessaryPermission: 'canShowDisputes',
  },
];
